export default __webpack_public_path__ + "static/media/886646ff-d2fa-4be8-b76f-eb2f9c335b6d.457a2f7d.JPG";